import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../../commonComponents/translate';
import FormInput from '../../../../../../commonComponents/forms/FormInput';
import ProfileField from '../../profile/ProfileField';
import FormSubtitle from '../../../../../../commonComponents/forms/FormSubtitle';
import CryptoWalletList from './components/CryptoWalletList';
import CryptoCurrencyNetworkProp from '../../../../../../commonComponents/propTypes/cryptoCurrencyNetworkProp';
import RequiredFieldsPerBlockProp from '../../../../../../commonComponents/propTypes/requiredFieldsPerBlockProp';
import { PROFILE_BLOCK } from '../../../../../../services/utilityFunctions';
import { isFieldRequiredLabel } from '../../../../helpers/helper';

function CompanyTab(props) {
  const {
    t,
    userInformation,
    onChange,
    onCryptoWalletChange,
    handleCryptoNetworkInformation,
    cryptoCurrenciesNetwork,
    vatPlaceholder,
    inputProps,
    onTaxChange,
    isBusinessTypesLoaded,
    requiredFieldsPerBlock,
    nifLabel,
  } = props;
  return (
    <div className="companyTab">
      <ProfileField
        field="companyName"
        type="text"
        value={userInformation.companyName}
        onChange={onChange}
        inputProps={inputProps}
        placeholder={t('profile_companyName')}
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      {isBusinessTypesLoaded ? (
        <ProfileField
          field="businessType"
          type="select"
          value={userInformation.businessType}
          onChange={onChange}
          inputProps={inputProps}
          placeholder={t('profile_businessType')}
          containerClassName="businessTypeWrapperContainer col-7"
          block={PROFILE_BLOCK.LEGAL_FINANCES}
          requiredFieldsPerBlock={requiredFieldsPerBlock}
        />
      ) : (
        <div className="form-group m-form__group  row ">
          <label
            htmlFor="businessTypePlacheholder"
            className="col-form-label col-lg-2 col-sm-12"
          >
            {t('profile_businessType')}
          </label>
          <div className="businessTypeWrapperContainer businessTypeWrapperContainerPlaceholder col-7">
            {`${t('loading.businessTypes')} ...`}
          </div>
        </div>
      )}
      <ProfileField
        field="taxType"
        type="select"
        value={userInformation.taxCode}
        onChange={onTaxChange}
        inputProps={inputProps}
        placeholder={t('profile_taxType')}
        containerClassName="taxCodeWrapperContainer col-7"
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <FormInput
        id="NIF"
        name="NIF"
        value={userInformation.NIF}
        labelClassName="col-lg-2 col-sm-12"
        containerClassName="col-lg-7 col-sm-12"
        onChange={change => onChange('NIF', change)}
        label={isFieldRequiredLabel(
          requiredFieldsPerBlock,
          PROFILE_BLOCK.LEGAL_FINANCES,
          'NIF',
          nifLabel,
        )}
        placeholder={vatPlaceholder.length > 0 ? vatPlaceholder : nifLabel}
        type="text"
        groupProps={{ className: 'row' }}
      />
      <ProfileField
        field="SIREN"
        placeholder={t('profile_SIREN')}
        value={userInformation.SIREN}
        onChange={onChange}
        hint={t('profile_SIREN.hint')}
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <ProfileField
        field="socialSecurityNumber"
        placeholder={t('profile_socialSecurityNumber')}
        value={userInformation.socialSecurityNumber}
        onChange={onChange}
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <FormSubtitle title={t('bank_account')} />
      <ProfileField
        field="IBAN"
        value={userInformation.IBAN}
        onChange={onChange}
        placeholder={t('profile_IBAN')}
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <ProfileField
        field="SWIFT"
        value={userInformation.SWIFT}
        onChange={onChange}
        placeholder={t('profile_SWIFT')}
        block={PROFILE_BLOCK.LEGAL_FINANCES}
        requiredFieldsPerBlock={requiredFieldsPerBlock}
      />
      <CryptoWalletList
        cryptoCurrenciesNetwork={cryptoCurrenciesNetwork}
        handleCryptoNetworkInformation={handleCryptoNetworkInformation}
        onCryptoWalletChange={onCryptoWalletChange}
        userInformation={userInformation}
      />
    </div>
  );
}

CompanyTab.propTypes = {
  t: PropTypes.func.isRequired,
  userInformation: PropTypes.shape({
    companyName: PropTypes.string.isRequired,
    socialSecurityNumber: PropTypes.string.isRequired,
    SWIFT: PropTypes.string.isRequired,
    SIREN: PropTypes.string.isRequired,
    taxCode: PropTypes.string.isRequired,
    IBAN: PropTypes.string.isRequired,
    cardId: PropTypes.string.isRequired,
    businessType: PropTypes.string.isRequired,
    NIF: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onCryptoWalletChange: PropTypes.func.isRequired,
  cryptoCurrenciesNetwork: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.shape(CryptoCurrencyNetworkProp.propType)),
  ).isRequired,
  handleCryptoNetworkInformation: PropTypes.func.isRequired,
  vatPlaceholder: PropTypes.string,
  onTaxChange: PropTypes.func.isRequired,
  inputProps: PropTypes.func.isRequired,
  isBusinessTypesLoaded: PropTypes.bool,
  requiredFieldsPerBlock: PropTypes.arrayOf(
    PropTypes.shape(RequiredFieldsPerBlockProp.propType),
  ),
  nifLabel: PropTypes.string.isRequired,
};

CompanyTab.defaultProps = {
  vatPlaceholder: '',
  isBusinessTypesLoaded: false,
  requiredFieldsPerBlock: RequiredFieldsPerBlockProp.defaultProp,
};

export default translate(CompanyTab);
